import { Component, OnInit, Input, SimpleChange } from '@angular/core';
import { ApiService } from 'src/app/Services/api.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from 'src/app/Services/storage.service';
@Component({
  selector: 'g10-roster-excel-mapping',
  templateUrl: './roster-excel-mapping.component.html',
  styleUrls: ['./roster-excel-mapping.component.css']
})
export class RosterExcelMappingComponent implements OnInit {
  public orgID:string;
  public fieldObj:any={};
  public headers:any=[];
  public rosterFieldMapForm: FormGroup;
  public formSubmit:boolean=false;
  public isValuesChange:boolean=true;
  public formSelectedFor:string='bothPickupDrop';
  public bothOrEitherObj:any={};
  public isDataValid:boolean=false;
  public safetyData:any={};
  public nestedHeader:any=[];
  public defaultObj:any={
    "isDefault":true,
    "S No": "S No",
    "Employee ID": "Employee ID",
    "Employee Name": "Employee Name",
    "Employee Mobile": "Employee Mobile",
    "Gender": "Gender",
    "Shift Time": "Shift Time",
    "bothPickupDrop":{
      "Pickup ETA": "Pickup ETA",
      "Pickup Address": "Pickup Address",
      "Pickup Vehicle Driver": "Pickup Vehicle Driver",
      "Drop ETA": "Drop ETA",
      "Drop Address": "Drop Address",
      "Drop Vehicle Driver": "Drop Vehicle Driver",
    },
    "eitherPickupDrop":{
      "Eta": "",
      "Address" : "",
      "vehRegNo" : "",
      "Driver Name": "",
      "Driver No": "",
      "Transit Mode": "",
    },
    "Area": "Area",
    "Trip sheet ID": "Trip sheet ID",
    "Branch": "Branch",
    "Project": "Project",
    "User Type": "User Type",
    "Vendor Name": "Vendor Name",
    "Mail ID": "mailid",
    "Driver Message": "driverMessage",
    "Landmark" : "landmark",
    "Start Time(P)" : "Start Time(P)",
    "End Time(P)" : "End Time(P)",
    "Start Location(P)" : "Start Location(P)",
    "End Location(P)" : "End Location(P)",
    "Start Time(D)" : "Start Time(D)",
    "End Time(D)" : "End Time(D)",
    "Start Location(D)" : "Start Location(D)",
    "End Location(D)" : "End Location(D)",
    "Notification" : {
        "pickup" : "instant",
        "drop" : "instant"
        }
  }
  public setManPickTime:boolean=false;
  public setManDropTime:boolean=false;

  public selectedPicTime:string='';
  public selectedDropTime:string='';

  constructor(
    private api: ApiService,
    public fb: FormBuilder,
    public swal: SweetAlert,
    public router: Router,
    public route:ActivatedRoute,
    public storage: StorageService,
  ) {
    this.route.paramMap.subscribe((params: any) => {
      this.orgID=params.params.orgID;
    });
    if(this.orgID==undefined){
      this.orgID=this.storage.get('orgID');
    }
  }

  ngOnInit(): void {
    this.loadForm();
    (async ()=>{
      if(this.orgID){
        const data = await this.getFieldMapData();
        this.fieldObj=data;
        await this.setValuesToForm();
      }else{
        this.fieldObj=this.defaultObj;
        this.headers=Object.keys(this.fieldObj);
        this.setDefaultValues();
      }
    })();
  }
  loadForm(){
    this.rosterFieldMapForm = new FormGroup({
      'headersFor': new FormControl('bothPickupDrop'),
      'S No': new FormControl('', [Validators.required]),
      'Employee ID': new FormControl('', [Validators.required]),
      'Employee Name': new FormControl('', [Validators.required]),
      'Employee Mobile': new FormControl('', [Validators.required]),
      'Gender': new FormControl('', [Validators.required]),
      'Shift Time': new FormControl('', [Validators.required]),
      'Area': new FormControl('', [Validators.required]),
      'Branch': new FormControl('', [Validators.required]),
      'Trip sheet ID': new FormControl('', [Validators.required]),
      'Mail ID': new FormControl('', [Validators.required]),
      'Driver Message': new FormControl('', [Validators.required]),
      'Landmark':new FormControl('', [Validators.required]),
      'Project': new FormControl('', [Validators.required]),
      'User Type': new FormControl('', [Validators.required]),
      'Vendor Name': new FormControl('', [Validators.required]),
      'Start Time(P)': new FormControl('', [Validators.required]),
      'End Time(P)': new FormControl('', [Validators.required]),
      'Start Location(P)': new FormControl('', [Validators.required]),
      'End Location(P)': new FormControl('', [Validators.required]),
      'Start Time(D)': new FormControl('', [Validators.required]),
      'End Time(D)': new FormControl('', [Validators.required]),
      'Start Location(D)': new FormControl('', [Validators.required]),
      'End Location(D)': new FormControl('', [Validators.required]),

      'pickup': new FormControl('instant'),
      'drop': new FormControl('instant'),
  });
  }
  getFieldMapData(){
    return new Promise((resolve, reject) => {
      try{
        let obj={
          orgID:this.orgID
        }
        this.api.masterRosterListMapping(obj).then((res:any)=>{
          if(res.status=='success'){
            if(res && res['data'] && res['data'].length > 0 && res.data[0]['rosters'] && res.data[0]['rosters']['excelMapping']){
              let data=res.data[0]['rosters']['excelMapping'];
              const obj={
                'isDefault': (data['isDefault'])?true:false,
                'S No':data['S No'] && data['S No']!=null?data['S No']:'',
                'Employee ID':data['Employee ID'] && data['Employee ID']!=null?data['Employee ID']:'',
                'Employee Name':data['Employee Name'] && data['Employee Name']!=null?data['Employee Name']:'',
                'Employee Mobile':data['Employee Mobile'] && data['Employee Mobile']!=null?data['Employee Mobile']:'',
                'Gender':data['Gender'] && data['Gender']!=null?data['Gender']:'',
                'Shift Time':data['Shift Time'] && data['Shift Time']!=null?data['Shift Time']:'',
                'Area':data['Area'] && data['Area']!=null?data['Area']:'',
                'Branch':data['Branch'] && data['Branch']!=null?data['Branch']:'',
                'Trip sheet ID':data['Trip sheet ID'] && data['Trip sheet ID']!=null?data['Trip sheet ID']:'',
                'Mail ID':data['Mail ID'] && data['Mail ID']!=null?data['Mail ID']:'',
                'Driver Message':data['Driver Message'] && data['Driver Message']!=null?data['Driver Message']:'',
                'Landmark':data['Landmark'] && data['Landmark']!=null?data['Landmark']:'',
                'Project':data['Project'] && data['Project']!=null?data['Project']:'',
                'User Type':data['User Type'] && data['User Type']!=null?data['User Type']:'',
                'Vendor Name':data['Vendor Name'] && data['Vendor Name']!=null?data['Vendor Name']:'',
                'Start Time(P)':data['Start Time(P)'] && data['Start Time(P)']!=null?data['Start Time(P)']:'',
                'End Time(P)':data['End Time(P)'] && data['End Time(P)']!=null?data['End Time(P)']:'',
                'Start Location(P)':data['Start Location(P)'] && data['Start Location(P)']!=null?data['Start Location(P)']:'',
                'End Location(P)':data['End Location(P)'] && data['End Location(P)']!=null?data['End Location(P)']:'',
                'Start Time(D)':data['Start Time(D)'] && data['Start Time(D)']!=null?data['Start Time(D)']:'',
                'End Time(D)':data['End Time(D)'] && data['End Time(D)']!=null?data['End Time(D)']:'',
                'Start Location(D)':data['Start Location(D)'] && data['Start Location(D)']!=null?data['Start Location(D)']:'',
                'End Location(D)':data['End Location(D)'] && data['End Location(D)']!=null?data['End Location(D)']:'',
                'bothPickupDrop':{
                  'Pickup ETA':data['Pickup ETA'] && data['Pickup ETA']!=null?data['Pickup ETA']:'',
                  'Pickup Address':data['Pickup Address'] && data['Pickup Address']!=null?data['Pickup Address']:'',
                  'Pickup Vehicle Driver':data['Pickup Vehicle Driver']&& data['Pickup Vehicle Driver']!=null?data['Pickup Vehicle Driver']:'',
                  'Drop ETA':data['Drop ETA']&& data['Drop ETA']!=null?data['Drop ETA']:'',
                  'Drop Address':data['Drop Address']&& data['Drop Address']!=null?data['Drop Address']:'',
                  'Drop Vehicle Driver':data['Drop Vehicle Driver']&& data['Drop Vehicle Driver']!=null?data['Drop Vehicle Driver']:'',
                },
                'eitherPickupDrop':{
                  'Eta':data['Eta']&&data['Eta']!=null?data['Eta']:'',
                  'Address':data['Address']&& data['Address']!=null?data['Address']:'',
                  'vehRegNo':data['vehRegNo'] && data['vehRegNo']!=null?data['vehRegNo']:'',
                  'Driver Name':data['Driver Name']&& data['Driver Name']!=null?data['Driver Name']:'',
                  'Driver No':data['Driver No']&& data['Driver No']!=null?data['Driver No']:'',
                  'Transit Mode':data['Transit Mode']&&data['Transit Mode']!=null?data['Transit Mode']:''
                },
                "Notification" : {
                  "pickup" : (data['Notification']&&data['Notification']['pickup'])?data['Notification']['pickup']:'instant',
                  "drop" :(data['Notification']&&data['Notification']['drop'])?data['Notification']['drop']:'instant'
                }
              }
              this.isValuesChange=(data['isDefault'])?true:false;
              this.fieldObj=obj;
              resolve(obj);
            }else{
              this.fieldObj=this.defaultObj;
              resolve(this.fieldObj);
            }
          }else{
            this.fieldObj=this.defaultObj;
            resolve(this.fieldObj);
          }
          this.headers=Object.keys(this.fieldObj);
        });
      }catch(e){
        console.log(e)
      }
    })
  }
  setValuesToForm(){
    this.selectedPicTime='';
    this.selectedDropTime='';
    this.rosterFieldMapForm.patchValue({
      'isDefault':this.fieldObj['isDefault'] ? true :false,
      'S No':this.fieldObj['S No'] && this.fieldObj['S No']!=null ? this.fieldObj['S No'] :'',
      'Employee ID':this.fieldObj['Employee ID'] && this.fieldObj['Employee ID']!= null ? this.fieldObj['Employee ID'] :'',
      'Employee Name':this.fieldObj['Employee Name'] && this.fieldObj['Employee Name'] ? this.fieldObj['Employee Name'] : '',
      'Employee Mobile':this.fieldObj['Employee Mobile']  && this.fieldObj['Employee Mobile']!=null ? this.fieldObj['Employee Mobile'] : '',
      'Gender':this.fieldObj['Gender'] && this.fieldObj['Gender']!=null ? this.fieldObj['Gender'] : '',
      'Shift Time':this.fieldObj['Shift Time'] && this.fieldObj['Shift Time'] !=null ? this.fieldObj['Shift Time'] :'',
      'Area':this.fieldObj['Area'] && this.fieldObj['Area']!=null ? this.fieldObj['Area'] :'',
      'Branch':this.fieldObj['Branch'] && this.fieldObj['Branch']!=null ? this.fieldObj['Branch']:'',
      'Trip sheet ID':this.fieldObj['Trip sheet ID'] && this.fieldObj['Trip sheet ID']!=null ? this.fieldObj['Trip sheet ID']:'',
      'Mail ID':this.fieldObj['Mail ID'] && this.fieldObj['Mail ID']!=null ? this.fieldObj['Mail ID'] :'',
      'Driver Message':this.fieldObj['Driver Message'] && this.fieldObj['Driver Message']!=null ?this.fieldObj['Driver Message']:'',
      'Landmark':this.fieldObj['Landmark'] && this.fieldObj['Landmark']!=null?this.fieldObj['Landmark']:'',
      'Project':this.fieldObj['Project'] && this.fieldObj['Project']!=null ? this.fieldObj['Project']:'',
      'User Type':this.fieldObj['User Type'] && this.fieldObj['User Type']!=null ?this.fieldObj['User Type']:'',
      'Vendor Name':this.fieldObj['Vendor Name'] && this.fieldObj['Vendor Name']!=null ?this.fieldObj['Vendor Name'] :'',
      'Start Time(P)':this.fieldObj['Start Time(P)'] && this.fieldObj['Start Time(P)']!=null ?this.fieldObj['Start Time(P)'] :'',
      'End Time(P)':this.fieldObj['End Time(P)'] && this.fieldObj['End Time(P)']!=null ?this.fieldObj['End Time(P)'] :'',
      'Start Location(P)':this.fieldObj['Start Location(P)'] && this.fieldObj['Start Location(P)']!=null ?this.fieldObj['Start Location(P)'] :'',
      'End Location(P)':this.fieldObj['End Location(P)'] && this.fieldObj['End Location(P)']!=null ?this.fieldObj['End Location(P)'] :'',
      'Start Time(D)':this.fieldObj['Start Time(D)'] && this.fieldObj['Start Time(D)']!=null ?this.fieldObj['Start Time(D)'] :'',
      'End Time(D)':this.fieldObj['End Time(D)'] && this.fieldObj['End Time(D)']!=null ?this.fieldObj['End Time(D)'] :'',
      'Start Location(D)':this.fieldObj['Start Location(D)'] && this.fieldObj['Start Location(D)']!=null ?this.fieldObj['Start Location(D)'] :'',
      'End Location(D)':this.fieldObj['End Location(D)'] && this.fieldObj['End Location(D)']!=null ?this.fieldObj['End Location(D)'] :'',
      'headersFor':(this.orgID && this.fieldObj.eitherPickupDrop && this.fieldObj.eitherPickupDrop['Eta'] && this.fieldObj.eitherPickupDrop['Address'] && this.fieldObj.eitherPickupDrop['vehRegNo']&&this.fieldObj.eitherPickupDrop['Driver Name']&&this.fieldObj.eitherPickupDrop['Driver No']&&this.fieldObj.eitherPickupDrop['Transit Mode'])?'eitherPickupDrop':'bothPickupDrop',
      'pickup':(this.fieldObj['Notification']&&this.fieldObj['Notification'].pickup != 'instant')?'schedule':'instant',
      'drop':(this.fieldObj['Notification']&&this.fieldObj['Notification'].drop != 'instant')?'schedule':'instant',
      'pickupTime':(this.fieldObj['Notification']&&this.fieldObj['Notification'].pickup !='instant')?this.fieldObj['Notification'].pickup:'',
      'dropTime':(this.fieldObj['Notification']&&this.fieldObj['Notification'].drop !='instant')?this.fieldObj['Notification'].drop:'',
    })
    this.selectedPicTime=(this.fieldObj['Notification']&&this.fieldObj['Notification'].pickup !='instant')?this.fieldObj['Notification'].pickup:'';
    this.selectedDropTime=(this.fieldObj['Notification']&&this.fieldObj['Notification'].drop !='instant')?this.fieldObj['Notification'].drop:'';
    this.fieldChange('headersFor',{value:this.rosterFieldMapForm.value.headersFor});
    this.fieldChange('pickup',{value:this.rosterFieldMapForm.value.pickup});
    this.fieldChange('drop',{value:this.rosterFieldMapForm.value.drop});
  }
  public checkError = (controlName: string, errorName: string) => {
    return this.rosterFieldMapForm.controls[controlName].hasError(errorName);
  }
  fieldChange(type,e){
    this.formSubmit=false;
    let value;
    if(type!='default'){
      value=e.value;
    }else if(type=='default'){
      value=e.checked;
    }
    if(type=='pickup'){
      if(value != 'instant'){
        this.rosterFieldMapForm.addControl('pickupTime',new FormControl('', [Validators.required]));
        this.setManPickTime=true;
      }else{
        this.rosterFieldMapForm.removeControl('pickupTime');
        this.setManPickTime=false;
      }
      this.rosterFieldMapForm.value.pickup=value;
    }
    if(type=='drop'){
      if(value != 'instant'){
        this.rosterFieldMapForm.addControl('dropTime',new FormControl('', [Validators.required]));
        this.setManDropTime=true;
      }else{
        this.rosterFieldMapForm.removeControl('dropTime');
        this.setManDropTime=false;
      }
      this.rosterFieldMapForm.value.drop=value;
    }
    if(type=='headersFor'){
      this.formSelectedFor=value;
      if(value=='bothPickupDrop'){
        this.nestedHeader=Object.keys(this.fieldObj.bothPickupDrop);
        this.rosterFieldMapForm.addControl('Pickup ETA',new FormControl(this.fieldObj.bothPickupDrop['Pickup ETA'], [Validators.required]));
        this.rosterFieldMapForm.addControl('Pickup Address',new FormControl(this.fieldObj.bothPickupDrop['Pickup Address'], [Validators.required]));
        this.rosterFieldMapForm.addControl('Pickup Vehicle Driver',new FormControl(this.fieldObj.bothPickupDrop['Pickup Vehicle Driver'], [Validators.required]));
        this.rosterFieldMapForm.addControl('Drop ETA',new FormControl(this.fieldObj.bothPickupDrop['Drop ETA'], [Validators.required]));
        this.rosterFieldMapForm.addControl('Drop Address',new FormControl(this.fieldObj.bothPickupDrop['Drop Address'], [Validators.required]));
        this.rosterFieldMapForm.addControl('Drop Vehicle Driver',new FormControl(this.fieldObj.bothPickupDrop['Drop Vehicle Driver'], [Validators.required]));
      
        this.rosterFieldMapForm.removeControl('Eta');
        this.rosterFieldMapForm.removeControl('Address');
        this.rosterFieldMapForm.removeControl('vehRegNo');
        this.rosterFieldMapForm.removeControl('Driver Name');
        this.rosterFieldMapForm.removeControl('Driver No');
        this.rosterFieldMapForm.removeControl('Transit Mode');
      }
      if(value=='eitherPickupDrop'){
        this.nestedHeader=Object.keys(this.fieldObj.eitherPickupDrop);
        this.rosterFieldMapForm.addControl('Eta',new FormControl(this.fieldObj.eitherPickupDrop['Eta'], [Validators.required]));
        this.rosterFieldMapForm.addControl('Address',new FormControl(this.fieldObj.eitherPickupDrop['Address'], [Validators.required]));
        this.rosterFieldMapForm.addControl('vehRegNo',new FormControl(this.fieldObj.eitherPickupDrop['vehRegNo'], [Validators.required]));
        this.rosterFieldMapForm.addControl('Driver Name',new FormControl(this.fieldObj.eitherPickupDrop['Driver Name'], [Validators.required]));
        this.rosterFieldMapForm.addControl('Driver No',new FormControl(this.fieldObj.eitherPickupDrop['Driver No'], [Validators.required]));
        this.rosterFieldMapForm.addControl('Transit Mode',new FormControl(this.fieldObj.eitherPickupDrop['Transit Mode'], [Validators.required]));
      
        this.rosterFieldMapForm.removeControl('Pickup ETA');
        this.rosterFieldMapForm.removeControl('Pickup Address');
        this.rosterFieldMapForm.removeControl('Pickup Vehicle Driver');
        this.rosterFieldMapForm.removeControl('Drop ETA');
        this.rosterFieldMapForm.removeControl('Drop Address');
        this.rosterFieldMapForm.removeControl('Drop Vehicle Driver');
      }
    }
    if(type=='default'){
      this.isValuesChange=value;
      if(this.isValuesChange){
        this.setManPickTime=false;
        this.setManDropTime=false;
        this.setDefaultValues();
      }else{
        this.setValuesToForm();
      }
    }
    if(this.isValuesChange){
      this.rosterFieldMapForm.disable();
    }else{
      this.rosterFieldMapForm.enable();
    }
  }
  setDefaultValues(){
    this.fieldChange('headersFor',{value:'bothPickupDrop'});
    this.selectedPicTime='';
    this.selectedDropTime='';
    this.rosterFieldMapForm.patchValue({
      'S No':this.defaultObj['S No'],
      'Employee ID':this.defaultObj['Employee ID'],
      'Employee Name':this.defaultObj['Employee Name'],
      'Employee Mobile':this.defaultObj['Employee Mobile'],
      'Gender':this.defaultObj['Gender'],
      'Shift Time':this.defaultObj['Shift Time'],
      'Area':this.defaultObj['Area'],
      'Branch':this.defaultObj['Branch'],
      'Trip sheet ID':this.defaultObj['Trip sheet ID'],
      'Mail ID':this.defaultObj['Mail ID'],
      'Driver Message':this.defaultObj['Driver Message'],
      'Landmark':this.defaultObj['Landmark'],
      'Project':this.defaultObj['Project'],
      'User Type':this.defaultObj['User Type'],
      'Vendor Name':this.defaultObj['Vendor Name'],
      'Start Time(P)':this.defaultObj['Start Time(P)'],
      'End Time(P)':this.defaultObj['End Time(P)'],
      'Start Location(P)':this.defaultObj['Start Location(P)'],
      'End Location(P)':this.defaultObj['End Location(P)'],
      'Start Time(D)':this.defaultObj['Start Time(D)'],
      'End Time(D)':this.defaultObj['End Time(D)'],
      'Start Location(D)':this.defaultObj['Start Location(D)'],
      'End Location(D)':this.defaultObj['End Location(D)'],
      'pickup':this.defaultObj.Notification['pickup'],
      'drop':this.defaultObj.Notification['drop'],
      'headersFor':'bothPickupDrop',
      'Pickup ETA':this.defaultObj.bothPickupDrop['Pickup ETA'],
      'Pickup Address':this.defaultObj.bothPickupDrop['Pickup Address'],
      'Pickup Vehicle Driver':this.defaultObj.bothPickupDrop['Pickup Vehicle Driver'],
      'Drop ETA':this.defaultObj.bothPickupDrop['Drop ETA'],
      'Drop Address':this.defaultObj.bothPickupDrop['Drop Address'],
      'Drop Vehicle Driver':this.defaultObj.bothPickupDrop['Drop Vehicle Driver'],
      'isDefault':true
    })
  }
  onSubmit(){
    this.formSubmit=true;
    let obj={};
    obj['orgID']=this.orgID,
    obj['S No']=this.rosterFieldMapForm.value['S No'],
    obj['Employee ID']=this.rosterFieldMapForm.value['Employee ID'],
    obj['Employee Name']=this.rosterFieldMapForm.value['Employee Name'],
    obj['Employee Mobile']=this.rosterFieldMapForm.value['Employee Mobile'],
    obj['Gender']=this.rosterFieldMapForm.value['Gender'],
    obj['Shift Time']=this.rosterFieldMapForm.value['Shift Time'],
    obj['Area']=this.rosterFieldMapForm.value['Area'],
    obj['Branch']=this.rosterFieldMapForm.value['Branch'],
    obj['Trip sheet ID']=this.rosterFieldMapForm.value['Trip sheet ID'],
    obj['Mail ID']=this.rosterFieldMapForm.value['Mail ID'],
    obj['Driver Message']=this.rosterFieldMapForm.value['Driver Message'],
    obj['Landmark']=this.rosterFieldMapForm.value['Landmark'],
    obj['Project']=this.rosterFieldMapForm.value['Project'],
    obj['User Type']=this.rosterFieldMapForm.value['User Type'],
    obj['Vendor Name']=this.rosterFieldMapForm.value['Vendor Name'],
    obj['Start Time(P)']=this.rosterFieldMapForm.value['Start Time(P)'],
    obj['End Time(P)']=this.rosterFieldMapForm.value['End Time(P)'],
    obj['Start Location(P)']=this.rosterFieldMapForm.value['Start Location(P)'],
    obj['End Location(P)']=this.rosterFieldMapForm.value['End Location(P)'],
    obj['Start Time(D)']=this.rosterFieldMapForm.value['Start Time(D)'],
    obj['End Time(D)']=this.rosterFieldMapForm.value['End Time(D)'],
    obj['Start Location(D)']=this.rosterFieldMapForm.value['Start Location(D)'],
    obj['End Location(D)']=this.rosterFieldMapForm.value['End Location(D)'],

    obj['isDefault']=this.isValuesChange;
    obj['Notification']={};
    if(this.rosterFieldMapForm.value.pickup!='instant'){
      obj['Notification']['pickup']=this.rosterFieldMapForm.value.pickupTime;
    }else if(this.rosterFieldMapForm.value.pickup=='instant'){
      obj['Notification']['pickup']=this.rosterFieldMapForm.value.pickup;
    }
    if(this.rosterFieldMapForm.value.drop!='instant'){
      obj['Notification']['drop']=this.rosterFieldMapForm.value.dropTime;
    }else if(this.rosterFieldMapForm.value.drop=='instant'){
      obj['Notification']['drop']=this.rosterFieldMapForm.value.drop;
    }
    if(this.fieldObj.bothPickupDrop && this.formSelectedFor=='bothPickupDrop'){
      obj['Pickup ETA']=this.rosterFieldMapForm.value['Pickup ETA'];
      obj['Pickup Address']=this.rosterFieldMapForm.value['Pickup Address'];
      obj['Pickup Vehicle Driver']=this.rosterFieldMapForm.value['Pickup Vehicle Driver'];
      obj['Drop ETA']=this.rosterFieldMapForm.value['Drop ETA'];
      obj['Drop Address']=this.rosterFieldMapForm.value['Drop Address'];
      obj['Drop Vehicle Driver']=this.rosterFieldMapForm.value['Drop Vehicle Driver'];
      delete obj['Eta'];
      delete obj['Address'];
      delete obj['vehRegNo'];
      delete obj['Driver Name'];
      delete obj['Driver No'];
      delete obj['Transit Mode'];
    }
    if(this.fieldObj.eitherPickupDrop && this.formSelectedFor=='eitherPickupDrop'){
      obj['Eta']=this.rosterFieldMapForm.value['Eta'];
      obj['Address']=this.rosterFieldMapForm.value['Address'];
      obj['vehRegNo']=this.rosterFieldMapForm.value['vehRegNo'];
      obj['Driver Name']=this.rosterFieldMapForm.value['Driver Name'];
      obj['Driver No']=this.rosterFieldMapForm.value['Driver No'];
      obj['Transit Mode']=this.rosterFieldMapForm.value['Transit Mode'];
      delete obj['Pickup ETA'];
      delete obj['Pickup Address'];
      delete obj['Pickup Vehicle Driver'];
      delete obj['Drop ETA'];
      delete obj['Drop Address'];
      delete obj['Drop Vehicle Driver'];
    }

    if(this.rosterFieldMapForm.valid && !this.isValuesChange){
      this.isDataValid=true;
    }else if(this.isValuesChange){
      this.isDataValid=true;
    }else{
      this.isDataValid=false;
    }
    if(this.isDataValid){
      this.api.masterRosterUpdateMapping(obj).then((res: any) => {
        if (res.status == 'success') {
          this.swal.swalFunction(res.status, res.status, res.message, 2000);
          this.router.navigateByUrl('master/organization/view-org');
        }
        if (res.status == 'failure') {
          this.swal.swalFunction('error', res.status, res.message, 3000);
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  }
  goBackToList(){
    this.router.navigateByUrl('master/organization/view-org');
  }
}
